import { C_LEAD_TYPE } from "shared/models/enums/lead_type.enum";
import { I_LeadsCounterValues } from "api/clients/leads counter/leads.counter.request";

const leadsCounterAdapter: I_LeadsCounterAdapter = (data) => {
  const isReferred = data.isReferred ? 1 : 0;
  return {
    params: {
      realestate_id: data.realestateId,
    },
    body: {
      type: data.type,
      people_id:
        data.isAgentReferer || isReferred == 0 ? data.idSelected : undefined,
      is_referred: isReferred,
      agency_id: data.isAgencyReferer ? data.idSelected : undefined,
    },
  };
};

export default leadsCounterAdapter;

type I_LeadsCounterAdapter = (
  data: I_LeadsCounterInput
) => I_LeadsCounterValues;

export interface I_LeadsCounterInput {
  realestateId: number;
  isReferred: boolean;
  isAgentReferer: boolean;
  isAgencyReferer: boolean;
  type: C_LEAD_TYPE;
  idSelected: number | undefined;
}
